import React, { useState, useEffect } from "react";
import styled from "styled-components";

function CallToAction() {
  return (
    <CallToActionStyle>
      <div className="cta">
        <p>
          let's make <span>magic</span> together
        </p>
      </div>
      <div className="cta-info">
        ...available to work in a team, or as an independent freelancer.
      </div>
      <a className="cta-info" href="mailto:folaborn2013@gmail.com">
        !lets - talk!
      </a>
      <div className="footer">
        {/* <div> &#8593; BACK TO TOP</div> */}
        <div>&#169; {new Date().getFullYear()}</div>
        <div>Designed and Developed by Samuel Afolabi</div>
      </div>
    </CallToActionStyle>
  );
}

export default CallToAction;
// styling
export const CallToActionStyle = styled.div`
  margin: 0 5px;
  text-transform: none;
  a {
    color: inherit;
  }
  .cta {
    margin-top: 10vw;
    font-family: "Monoton", cursive;
    text-transform: lowercase;
    font-family: "Monoton", cursive;
    font-size: 5.5vw;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    animation: bg-animation ease-out 3s infinite;
    background-size: 300%;
    background-image: linear-gradient(
      270deg,
      #ffffff -26.42%,
      rgba(255, 255, 255, 0) 159.02%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .cta-info {
    font-size: 1.8vw;
    display: flex;
    justify-content: center;
  }
  .footer {
    margin-top: 15vw;
    display: flex;
    justify-content: space-between;
  }
  @media only screen and (max-width: 600px) {
    .cta {
      margin-top: 10rem;
    }
    .cta-info {
      font-size: 1.6rem;
    }
    .footer {
      font-size: 1.2rem;
    }
  }
`;
